/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import dayjs from 'dayjs';
import { Search, TrendingUp, TrendingDown, Banknote } from 'lucide-react';
import { TransactionModal } from '../../components/Modal';
import financeConstant from 'utils/constants/finance.constant';
import {
  Box,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import SavingsIcon from '@mui/icons-material/Savings';
import ListPayment from '../Gold/components/ListPayment';
import ModalSetupFinance from '../Gold/components/ModalSetupFinance';
import SetupInitialMoney from 'views/Component/SetupInitialMoney';
export default function DetailPaymentAnother({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const paymentOther = useSelector((state) => state.paymentOther);
  const bank = useSelector((state) => state.bank);
  const finance = useSelector((state) => state.finance);
  const me = useSelector((state) => state.me);
  const transfers = useSelector((state) => state.gold || []);
  const transferlist = transfers?.rows || [];
  const [selectedBank, setSelectedBank] = useState('all');
  const [selectedType, setSelectedType] = useState();
  const [selectedTransactionType, setSelectedTransactionType] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [date, setDate] = useState(dayjs());
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [startingBalanceModalOpen, setStartingBalanceModalOpen] =
    useState(false);
  const [openSetupModal, setOpenSetupModal] = useState(false);
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const banknothide = bank?.rows?.filter((b) => b?.hide !== true) || [];
  console.log('banknothide', banknothide);

  const fetchData = async () => {
    try {
      await dispatch(actions.paymentOtherAll({ date: '' }));
      await dispatch(actions.bankAll());
      await dispatch(actions.financeAll());
      await dispatch(
        actions.goldTransactionAlltransfer({ transfer: true, size, page }),
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, size, page]);

  // --- กรองข้อมูล ---
  const filteredTransection =
    transferlist?.filter((transfer) => {
      const matchesBank =
        selectedBank === 'all' ||
        transfer?.payment?.transfer?.bank?.name === selectedBank;
      const matchesSearch = _.some(transfer?.order, (item) =>
        item?.material?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      return matchesBank && matchesSearch;
    }) || [];

  const filterPayment =
    paymentOther?.rows?.filter((transfer) => {
      const chMatch = bank?.rows?.filter((b) => b?._id === transfer?.bankId);
      const matchesBank =
        selectedBank === 'all' || chMatch[0]?.name === selectedBank;
      const matchesSearch = transfer?.paymentlist
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase());
      return matchesBank && matchesSearch;
    }) || [];

  const filteredTransfer = [...filteredTransection, ...filterPayment];
  const getSelectedBankSummary = () => {
    if (selectedBank === 'all') {
      return {
        bankName: 'ทั้งหมด',
        totalBalance: bank?.totalBalance,
        income: bank?.totalIncome,
        expense: bank?.totalOutcome,
      };
    }

    // else: เลือก bank ทีละบัญชี โดยใช้ _id
    const selectedList = bank?.rows?.filter((b) => b?._id === selectedBank);

    return {
      bankName: selectedList[0]?.bankName || 'ไม่พบข้อมูล',
      totalBalance: selectedList[0]?.income - selectedList[0]?.outcome,
      income: _.sumBy(selectedList, 'income'),
      expense: _.sumBy(selectedList, 'outcome'),
    };
  };

  const selectedBankSummary = getSelectedBankSummary();

  const formatCurrency = (value) => {
    if (typeof value !== 'number') value = 0;
    const formatter = new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 2,
    });
    return (value < 0 ? '- ' : '') + formatter.format(Math.abs(value));
  };

  return (
    <div>
      <div> {renderTitle()}</div>
      <div className="flex flex-row justify-start pb-4">
        <div>
          <BackButton />
        </div>
      </div>
      <div className="max-w-7xl mx-auto p-4 md:p-6 bg-gray-50 min-h-screen">
        {/* Header Summary - [ปรับปรุง UI] */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h1 className="text-2xl font-bold text-gray-800 flex items-center mb-4">
            <Banknote className="mr-3 text-yellow-600" size={28} />
            รายละเอียดการชำระเงิน
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-blue-100 text-blue-800 p-4 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-blue-600 text-sm">ยอดคงเหลือรวม</p>
                  <p className="text-2xl font-bold">
                    {formatCurrency(bank?.totalBalance)}
                  </p>
                </div>
                <Banknote size={32} className="text-blue-500" />
              </div>
            </div>
            <div className="bg-green-100 text-green-800 p-4 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-green-600 text-sm">เงินเข้า</p>
                  <p className="text-2xl font-bold">
                    {formatCurrency(bank?.totalIncome)}
                  </p>
                </div>
                <TrendingUp size={32} className="text-green-500" />
              </div>
            </div>
            <div className="bg-red-100 text-red-800 p-4 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-red-600 text-sm">เงินออก</p>
                  <p className="text-2xl font-bold">
                    {formatCurrency(bank?.totalOutcome)}
                  </p>
                </div>
                <TrendingDown size={32} className="text-red-500" />
              </div>
            </div>
          </div>
        </div>

        {/* Selected Bank Summary - [ปรับปรุง UI] */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            สรุปยอด:{' '}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-100 p-4 rounded-lg text-center">
              <p className="text-gray-600 text-sm mb-1">ยอดคงเหลือ</p>
              <p className="text-lg font-bold text-blue-700">
                {formatCurrency(selectedBankSummary?.totalBalance)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg text-center">
              <p className="text-gray-600 text-sm mb-1">เงินเข้า</p>
              <p className="text-lg font-bold text-green-700">
                {formatCurrency(selectedBankSummary?.income)}
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg text-center">
              <p className="text-gray-600 text-sm mb-1">เงินออก</p>
              <p className="text-lg font-bold text-red-700">
                {formatCurrency(selectedBankSummary?.expense)}
              </p>
            </div>
          </div>
        </div>

        {/* Bank/Cash Carousel - [ปรับปรุง UI + Logic] */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-5 flex justify-between items-center">
            <div>บัญชีธนาคารและเงินสด</div>
            <Button
              variant="contained"
              size="small"
              onClick={() => setOpenSetupModal(true)}
            >
              เงินตั้งต้น
            </Button>
            <SetupInitialMoney
              open={openSetupModal}
              onClose={() => setOpenSetupModal(false)}
              bank={banknothide}
            />
          </h2>

          <div className="flex gap-5 overflow-x-auto pb-2">
            {_.map(banknothide, (b) => (
              <div
                key={b?._id}
                className="
    flex-none w-64 rounded-lg bg-white border border-gray-200
    shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer
  "
              >
                {/* Header with Background */}
                <div className="bg-gradient-to-r from-blue-800 to-blue-700 text-white px-5 py-3 rounded-t-lg">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-lg tracking-wide">
                      {b?.name || b?.bankName}
                    </h3>

                    {/* <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                      <SavingsIcon className="text-white" fontSize="small" />
                    </div> */}
                  </div>
                </div>

                {/* Body */}
                <div className="px-5 py-4">
                  <p className="text-gray-500 text-sm font-bold">
                    ยอดเงินคงเหลือ
                  </p>

                  <p
                    className={`
        text-2xl font-bold mt-1 tracking-tight
        text-blue-700
      `}
                  >
                    {Number(b?.currentAmount).toLocaleString()} ฿
                  </p>

                  <p className="text-gray-400 text-xs mt-2">
                    อัปเดตล่าสุด: {dayjs(b?.updatedAt).format('DD/MM/YYYY')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Filter/Action Bar */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex flex-col md:flex-row flex-wrap gap-4 justify-end">
            {/* เลือกที่มาธุรกรรม */}
            <select
              value={selectedTransactionType}
              onChange={(e) => setSelectedTransactionType(e.target.value)}
              className="px-4 py-2 border rounded-lg w-full md:w-auto"
            >
              <option value="">เลือกที่มาของธุรกรรม</option>
              <option value="INCOME">เงินตั้งต้น</option>
              <option value="GOLD_SALE">ขายทอง</option>
              <option value="GOLD_PURCHASE">ซื้อทอง</option>
              <option value="OTHER">อื่นๆ</option>
            </select>

            {/* เลือกรายการธุรกรรม */}
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="px-4 py-2 border rounded-lg w-full md:w-auto"
            >
              <option value="">เลือกรายการธุรกรรม</option>
              <option value="INCOME">เงินสดเข้า</option>
              <option value="EXPENSE">เงินสดออก</option>
              <option value="TRANSFER_IN">โอนเข้า</option>
              <option value="TRANSFER_OUT">โอนออก</option>
            </select>

            {/* ธนาคาร */}
            <select
              value={selectedBank}
              onChange={(e) => setSelectedBank(e.target.value)}
              className="px-4 py-2 border rounded-lg w-full md:w-auto"
            >
              <option value="all">ทั้งหมด</option>
              {_.map(banknothide, (b) => (
                <option key={b?._id} value={b?._id}>
                  {b?.name || b?.bankName}
                </option>
              ))}
            </select>

            {/* Modal ธุรกรรม */}
            <TransactionModal
              date={date}
              me={me}
              dispatch={dispatch}
              actions={actions}
              banks={banknothide || []}
              fetchData={fetchData}
            />

            {/* ปุ่มเงินตั้งต้น */}
            <button
              onClick={() => setStartingBalanceModalOpen(true)}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition flex items-center justify-center w-full md:w-auto"
            >
              <SavingsIcon className="mr-2" size={20} />
              ตั้งค่าเงินตั้งต้น
            </button>
          </div>
        </div>

        <ListPayment
          filteredTransfer={filteredTransfer}
          bank={bank?.rows}
          selectedType={selectedType}
          selectedBank={selectedBank}
          selectedTransactionType={selectedTransactionType}
        />
      </div>
      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        {/* <TablePagination
          component="div"
          count={transfers?.total || 0}
          page={page - 1}
          rowsPerPage={size}
          onPageChange={(e, newPage) => setPage(newPage + 1)}
          onRowsPerPageChange={(e) => {
            setSize(parseInt(e.target.value, 10));
            setPage(1);
          }}
          labelRowsPerPage="แสดงรายการต่อหน้า:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} จาก ${count !== -1 ? count : `มากกว่า ${to}`}`
          }
        /> */}
      </Box>
      {/* --- [ใหม่] Modal สำหรับเงินตั้งต้น (กรอกพร้อมกัน) --- */}
      <ModalSetupFinance
        open={startingBalanceModalOpen}
        onClose={() => setStartingBalanceModalOpen(false)} // 👈 ส่งฟังก์ชันปิด
        accounts={banknothide} // 👈 ส่งข้อมูลบัญชี
        onSaveSuccess={fetchData} // 👈 ส่งฟังก์ชัน fetchData ไปให้ลูกเรียก
      />
    </div>
  );
}
DetailPaymentAnother.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailPaymentAnother.defaultProps = {
  title: '',
  subtitle: '',
};
